export const OMS_TUTORIAL_URL = '/tutorial/oms/';

export type TutorialWindowOpen = (
  url?: string | URL,
  target?: string,
  features?: string,
) => Window | null;

export const openOmsTutorial = (openWindow?: TutorialWindowOpen) => {
  const opener = openWindow ?? window.open.bind(window);

  return opener(OMS_TUTORIAL_URL, '_blank', 'noopener,noreferrer');
};
